/* eslint-disable max-params */
import GetMoviedataReturn from './GetMoviedataReturn'
import React, { useState } from 'react'
import { listNonArrayString } from '../Components/Data/MovieStaticData'
import filterMoviesAndPersons from '../Services/Queries/GetMovieListData'
import './Searchbar.css'
export default function GetMovieData(props) {
  const [selectedCastData, setSelectedCastData] = useState([])
  const [selectedCrewProd, setselectedCrewProd] = useState([])
  const [selectedCrewDirector, setSelectedCrewDirector] = useState([])
  const [selectedCrewEditor, setselectedCrewEditor] = useState([])
  const [selectedCrewDialog, setSelectedCrewDialog] = useState([])
  const [selectedCrewMusic, setselectedCrewMusic] = useState([])
  const [selectedCrewCenimato, setselectedCrewCenimato] = useState([])
  const [Ratingvalue, setRatingvalue] = useState(0)
  const [agevalue, setagevalue] = useState('')
  const [isExpandAll, setExpandAll] = useState({ castAccordian: true, crewAccordian: true })
  const [checkproducer, setcheckmovieProducedBy] = useState(false)
  const [checkPopularMovie, setcheckPopularMovie] = useState('')
  const [GOAT, setGOAT] = useState('')
  const [originalLanguageTelugu, setoriginalLanguageTelugu] = useState('')
  const [statemovieDirectedBy, setstatemovieDirectedBy] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [checkposterlink, setcheckPosterurl] = useState(false)
  const [selectedOthers, setselectedOthers] = useState([])
  const [selectedAbout, setselectedAbout] = useState([])
  const [selectedOTT, setSelectedOTT] = useState([])
  const [selectedGenres, setSelectedGenres] = useState([])
  const [ToRatingvalue, setToRatingvalue] = useState(0)
  const [ResetAccordianData, setResetAccordianData] = useState(false)
  const [SearchPerson, setSearchPerson] = useState('')
  const [SearchPersonProd, setSearchPersonProd] = useState('')
  const [SearchPersonEditor, setSearchPersonEditor] = useState('')
  const [SearchPersonCenimato, setSearchPersonCenimato] = useState('')
  const [SearchPersonMusic, setSearchPersonMusic] = useState('')
  const [SearchPersonDialog, setSearchPersonDialog] = useState('')
  const [SearchPersonCast, setSearchPersonCast] = useState('')
  const AfterInitialLoad = 20
  let { movieFilterBy, limitval, sortBy, setsortBy } = props

  function CheckBoxClick() {
    props.setSearchListTrue(false)
    props.setCheckTrue(!props.checkTrue)
    props.setShowDates(false)
    if (props.checkTrue === false) {
      delete movieFilterBy.movieReleaseStartDate
      delete movieFilterBy.movieReleaseEndDate
      movieFilterBy.movieReleaseStartDate = 0
      movieFilterBy.movieReleaseEndDate = 0
    } else {
      delete movieFilterBy.movieReleaseStartDate
      delete movieFilterBy.movieReleaseEndDate
    }
  }

  const handleFilterChange = (filterType, value) => {
    props.setFromvalue(AfterInitialLoad)
    setcheckPopularMovie(filterType === 'popularMovie' ? value : checkPopularMovie)
    setGOAT(filterType === 'GOAT' ? value : GOAT)
    setoriginalLanguageTelugu(
      filterType === 'originalLanguageTelugu' ? value : originalLanguageTelugu,
    )
    movieFilterBy[filterType] = value
  }

  const handlePopularMovie = e => handleFilterChange('popularMovie', e.target.value)
  const handleGOAT = e => handleFilterChange('GOAT', e.target.value)
  const handleoriginalLanguage = e => handleFilterChange('originalLanguageTelugu', e.target.value)

  function resethandleData() {
    setIsLoading(true)
    setResetAccordianData('reset')
    setToRatingvalue(0)
    props.setsortOrderBy('desc')
    setsortBy('releaseYear')
    setRatingvalue(0)
    setcheckmovieProducedBy(false)
    setstatemovieDirectedBy(false)
    setSelectedGenres('')
    setSelectedOTT('')
    setcheckPosterurl(false)
    setselectedOthers('')
    setselectedAbout('')
    setIsLoading(false)
    handleOnChange()
    setGOAT('')
    setoriginalLanguageTelugu('')
  }

  const changeCategoryGenre = selectedOption => {
    props.setSearchListTrue(false)
    if (selectedOption && selectedOption.length > 0) {
      movieFilterBy.genre_En = selectedOption && selectedOption.map(values => values.label)
    } else {
      delete movieFilterBy.genre_En
    }

    setSelectedGenres(selectedOption)
  }

  const handleChange = (e, isToRating = false) => {
    (isToRating ? setToRatingvalue : setRatingvalue)(e.target.value)
    props.setFromvalue(AfterInitialLoad)
    if (e.target.value < 100) {
      movieFilterBy[isToRating ? 'toRating' : 'fromRating'] = e.target.value || undefined
      setsortBy('popularity')
    }
  }

  const handleCategoryChange = (selectedOption, categoryKey, valueMapper) => {
    const value = valueMapper ? valueMapper(selectedOption) : selectedOption
    movieFilterBy[categoryKey] = value
    props.setFromvalue(AfterInitialLoad)
    props.setSearchListTrue(false)
    if (categoryKey === 'ottPlatform') {
      setSelectedOTT(selectedOption)
    } else if (categoryKey === 'ageRestriction') {
      setagevalue(value)
    }
  }

  const changeAbout = selectedOption => {
    props.setSearchListTrue(false)
    props.setFromvalue(AfterInitialLoad)
    setselectedAbout(selectedOption)
  }

  const changeCategoryAge = e => handleCategoryChange(e.target.value, 'ageRestriction')

  const changeCategoryOTT = selectedOption => handleCategoryChange(selectedOption, 'ottPlatform', selectedOption =>
      selectedOption && selectedOption.length > 0 ? selectedOption.map(values => values.label) : undefined,
    )

  const changeCategoryRating = e => handleChange(e)
  const changeCategoryRatingTo = e => handleChange(e, true)
  const handleOnChange = () => setExpandAll({ castAccordian: false, crewAccordian: false })

  function checkPosterurl() {
    props.setFromvalue(AfterInitialLoad)
    setcheckPosterurl(!checkposterlink)
    if (checkposterlink === false) {
      movieFilterBy.posterURL = 'none'
    } else {
      delete movieFilterBy.posterURL
    }
  }

  function checkmovieProducedBy() {
    props.setFromvalue(AfterInitialLoad)
    setcheckmovieProducedBy(!checkproducer)
    if (checkproducer === false) {
      movieFilterBy.producedBy_En = 'none'
    } else {
      delete movieFilterBy.producedBy_En
    }
  }

  function movieDirectedBy() {
    props.setFromvalue(AfterInitialLoad)
    setstatemovieDirectedBy(!statemovieDirectedBy)
    if (statemovieDirectedBy === false) {
      movieFilterBy.directedBy_En = 'none'
    } else {
      delete movieFilterBy.directedBy_En
    }
  }

  function PersonCrewFilterData(data, crewOrCastData, castOrCrewFilterBy, condition) {
    if (data.length > 0) {
      movieFilterBy[castOrCrewFilterBy] = condition
      movieFilterBy[crewOrCastData] = data
    } else {
      delete movieFilterBy[crewOrCastData]
      delete movieFilterBy[castOrCrewFilterBy]
    }
  }

  const getMoviesFilterData = async () => {
    props.setTotalRenderedCount(40)
    props.setFromvalue(AfterInitialLoad)
    setIsLoading(true)
    props.setCheckBoxArr([])
    const filterByOptions = { ...movieFilterBy }

    if (selectedAbout.length > 0) {
      selectedAbout.forEach(item => {
        filterByOptions[item.label] = 'none'
      })
    }

    if (selectedOthers.length > 0) {
      props.setFromvalue(AfterInitialLoad)
      selectedOthers.forEach(item => {
        if (listNonArrayString.includes(item.label)) {
          filterByOptions[item.label] = 'none'
        } else if (
          item.label === 'movieReleaseStartDate' ||
          item.label === 'movieReleaseEndDate' ||
          item.label === 'movieRating'
        ) {
          filterByOptions[item.label] = 0
        } else {
          filterByOptions[item.label] = ['none']
        }
      })
    }

    let totalrenderedcount = 0
    movieFilterBy = filterByOptions
    const input = {}
    input.limit = limitval
    input.from = 0
    input.sortOrder = props.sortByorder
    input.sortBy = sortBy
    input.search = props.searchValue
    input.type = props.movieAndWebSeries
    input.movieFilterBy = movieFilterBy
    const movieList = await filterMoviesAndPersons(input)
    setIsLoading(false)
    props.setmovieFilterByFromSearch(movieFilterBy)
    props.setcheckEmptyArray(movieList.items && movieList.items.length === 0)
    props.setsortByorderFromLIst(props.sortByorder)
    totalrenderedcount += AfterInitialLoad

    if (totalrenderedcount < movieList.total) {
      props.setLodeMoreDisble(false)
    } else {
      props.setLodeMoreDisble(true)
    }

    props.setListMoviesDataItems(movieList.items)
    props.setLoaderServiceName('filterMoviesAndPersons')
  }

  return (
    <GetMoviedataReturn
      setcheckPopularMovie={setcheckPopularMovie}
      GOAT={GOAT}
      originalLanguageTelugu={originalLanguageTelugu}
      checkPopularMovie={checkPopularMovie}
      handlePepularMovie={handlePopularMovie}
      handleGOAT={handleGOAT}
      handleoriginalLanguage={handleoriginalLanguage}
      movieFilterBy={movieFilterBy}
      setsortOrderBy={props.setsortOrderBy}
      setselectedOthers={setselectedOthers}
      setsortBy={setsortBy}
      setSearchListTrue={props.setSearchListTrue}
      sortBy={sortBy}
      isExpandAll={isExpandAll}
      setExpandAll={setExpandAll}
      SearchPersonCast={SearchPersonCast}
      setSearchPersonCast={setSearchPersonCast}
      setSearchPersonProd={setSearchPersonProd}
      SearchPersonProd={SearchPersonProd}
      setSearchPersonEditor={setSearchPersonEditor}
      SearchPersonEditor={SearchPersonEditor}
      setSearchPersonCenimato={setSearchPersonCenimato}
      SearchPersonCenimato={SearchPersonCenimato}
      setSearchPersonMusic={setSearchPersonMusic}
      SearchPersonMusic={SearchPersonMusic}
      setSearchPersonDialog={setSearchPersonDialog}
      SearchPersonDialog={SearchPersonDialog}
      SearchPerson={SearchPerson}
      setSearchPerson={setSearchPerson}
      ResetAccordianData={ResetAccordianData}
      PersonCrewFilterData={PersonCrewFilterData}
      movieAndWebSeries={props.movieAndWebSeries}
      ToRatingvalue={ToRatingvalue}
      changeCategoryRatingTo={changeCategoryRatingTo}
      disapperAllFilters={props.disapperAllFilters}
      searchValue={props.searchValue}
      sortOrderReset={props.sortOrderReset}
      sortByReset={props.sortByReset}
      setagevalue={setagevalue}
      showDates={props.showDates}
      showDatePicker={props.showDatePicker}
      setfilterDisableWithoutSelect={props.setfilterDisableWithoutSelect}
      setFromvalue={props.setFromvalue}
      filterDisableWithoutSelect={props.filterDisableWithoutSelect}
      statusType={props.statusType}
      isLoading={isLoading}
      checkTrue={props.checkTrue}
      selectedGenres={selectedGenres}
      changeCategoryAge={changeCategoryAge}
      agevalue={agevalue}
      changeCategoryGenre={changeCategoryGenre}
      selectedOTT={selectedOTT}
      changeCategoryOTT={changeCategoryOTT}
      Ratingvalue={Ratingvalue}
      changeCategoryRating={changeCategoryRating}
      selectedOthers={selectedOthers}
      checkposterlink={checkposterlink}
      checkPosterurl={checkPosterurl}
      changeAbout={changeAbout}
      selectedAbout={selectedAbout}
      handleResetData={props.handleResetData}
      statemovieDirectedBy={statemovieDirectedBy}
      movieDirectedBy={movieDirectedBy}
      checkmovieProducedBy={checkmovieProducedBy}
      handleFilterChange={handleFilterChange}
      checkproducer={checkproducer}
      sortByorder={props.sortByorder}
      CheckBoxClick={CheckBoxClick}
      resethandleData={resethandleData}
      getMoviesFilterData={getMoviesFilterData}
      selectedCastData={selectedCastData}
      setSelectedCastData={setSelectedCastData}
      setselectedCrewProd={setselectedCrewProd}
      setSelectedCrewDirector={setSelectedCrewDirector}
      setselectedCrewEditor={setselectedCrewEditor}
      setSelectedCrewDialog={setSelectedCrewDialog}
      setselectedCrewMusic={setselectedCrewMusic}
      selectedCrewProd={selectedCrewProd}
      selectedCrewDirector={selectedCrewDirector}
      selectedCrewEditor={selectedCrewEditor}
      selectedCrewDialog={selectedCrewDialog}
      selectedCrewMusic={selectedCrewMusic}
      selectedCrewCenimato={selectedCrewCenimato}
      setselectedCrewCenimato={setselectedCrewCenimato}
    />
  )
}
